:host {
  display: block;
  .loader-container {
    height: 254px;
    border-radius: 10px;
  }
}
